// Utility Functions

/**
 * Format category name for URL
 */
export const formatCategoryForUrl = (categoryName) => {
  const mapping = {
    'Home Decore & Gifts': 'homeDecoreGifts',
    'Kitchenware': 'kitchenware',
    'Furniture': 'furniture',
    'Lamps': 'lamps',
  };
  return mapping[categoryName] || categoryName.toLowerCase();
};

/**
 * Get category display name from URL slug
 */
export const getCategoryDisplayName = (slug) => {
  const mapping = {
    'homeDecoreGifts': 'Home Decore & Gifts',
    'kitchenware': 'Kitchenware',
    'furniture': 'Furniture',
    'lamps': 'Lamps',
  };
  return mapping[slug] || slug;
};

/**
 * Create mailto link
 */
export const createMailtoLink = (email, subject, body) => {
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);
  return `mailto:${email}?subject=${encodedSubject}&body=${encodedBody}`;
};

/**
 * Save to localStorage
 */
export const saveToLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

/**
 * Get from localStorage
 */
export const getFromLocalStorage = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return null;
  }
};

/**
 * Save string to localStorage (for simple values like email)
 */
export const saveStringToLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

/**
 * Get string from localStorage
 */
export const getStringFromLocalStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return null;
  }
};

